import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Modal, Table, Alert, Spinner } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import { ViewManager } from '../../core/view-manager';
import FieldPreview from '../../components/Entity/FieldPreview';
import ModalListPicker from '../../components/Modals/ModalListPicker';


export default function DataGridSelectionHook({ data, setData, entity = null, selectedRows, setSelectedRows, refreshData }) {


    const navigate = useNavigate()
    const [idEpisodeSelected, setIdEpisodeSelected] = useState(null);

    useEffect(() => {
        console.log(selectedRows)
    }, []);


    const [showModal, setShowModal] = useState(null);
    function closeModal() {
        setShowModal(false)
    }
    function openModal() {
        setShowModal(true)
    }

    const [showModalAll, setShowModalAll] = useState(null);
    function closeModalAll() {
        setShowModalAll(false)
    }
    function openModalAll() {
        setShowModalAll(true)
    }

    function selectRow(el) {
        console.log(el)
        setIdEpisodeSelected(el)
        closeModalAll()
        openModalConfirm()
    }

    async function completeEpisode() {
        var count = 0;
        var temp = [];
        for (let i = 0; i < selectedRows.length; i++) {
            var body = {
                isCompleted: 1
            }
            var res = await DataManager.updateItem('episode_user', body, selectedRows[i]);
            if (res.success === 1) {
                count++;
            } else {
                temp.push(selectedRows[i])
            }
        }
        if (count === selectedRows.length) {
            toast.success("Episodi COMPLETATI con successo.", { theme: 'colored' })
            closeModal()
            refreshData()
        } else {
            toast.error("Errore nel completare gli episodi. Episodi: " + temp.toString(), { theme: 'colored' })
        }

    }


    const [showModalConfirm, setShowModalConfirm] = useState(null);
    function closeModalConfirm() {
        setShowModalConfirm(false)
    }
    function openModalConfirm() {
        setShowModalConfirm(true)
    }

    async function completeEpisodeAllUsers() {
        var arrayUsers = []
        let constraints = [
            {
                "fieldName": "idEpisode",
                "type": "value",
                "value": idEpisodeSelected.id
            },
            {
                "fieldName": "isCompleted",
                "type": "different_from_value",
                "value": 1
            }
        ]
        let sorting = { "field": 'id', "order": "desc" }
        var response = await DataManager.searchItems('gyv_episode_user', 1, 1000, sorting, '', [], constraints);
        if (response.success === 1) {
            if (response.body.length > 0) {
                var count = 0;
                for (let i = 0; i < response.body.length; i++) {
                    var body = {
                        idCompleted: 1
                    }
                    var res = await DataManager.updateItem('episode_user', body, response.body[i].author);
                    if (res.success === 1) {
                        count++;
                    }
                }
                if (count !== response.body.length) {
                    toast.success("A tutti gli utenti è stato impostato COMPLETATO a questo episodio.", { theme: 'colored' })
                } else {
                    toast.error("Errore nel completare gli episodi.", { theme: 'colored' })
                }
            }
        }
    }



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'test': return (
                            <span>Test</span>
                        );
                        case 'gyv_episode_user': return (
                            <>
                                {selectedRows && selectedRows.length !== 0 ? <>
                                    <Button size={'sm'} variant='outline-success' onClick={() => openModal()}>Completa episodi</Button>
                                </> : null}



                                <Modal show={showModal} onHide={closeModal} size='lg'>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Completa episodio</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Sei sicuro di voler impostare come completati gli episodi selezionati?</Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="outline-danger" onClick={closeModal}>
                                            Annulla
                                        </Button>
                                        <Button variant="success" onClick={() => completeEpisode()}>
                                            Completa
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};